<template>
<div id="temp1" >  
<image-library-sidebar @setImg="setImg" :isSidebarActive="ViewSidebar"   @closeSidebar="toggleImageSidebar"/>
 <vs-row id="myHeader" >
  <vs-col  vs-type="flex" vs-justify="flex-start" vs-w="3" style="background-color:#FFFFFF ">
    <ul id="menu" class="justify-center items-center m-3">
      <vs-input  v-model="dataName" placeholder="Enter Name" class="w-full" name="Name" v-validate="'required'" maxlength="100"/>
      <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
     </ul>
      </vs-col>
  <vs-col  vs-type="flex" vs-justify="flex-start" vs-w="9" style="background-color:#FFFFFF ">
     <ul id="menu" class="m-3 flex justify-center items-center " v-if="showImg">
      <li>
        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
        <vs-button  type="flat" class="vs-con-loading__container"  id="div-changeimg-loading" @click.native="$refs.updateImgInput.click()">Change Image</vs-button>
      </li>
       <li> 
        <feather-icon icon="TrashIcon" class="mt-3" svgClasses="h-5 w-5" @click="removeObj()"/>
      </li>
    </ul>
     <ul id="menu" class="m-3 flex justify-center items-center" v-if="showText">
      <li > 
        <vs-tooltip text="Font Family" position="bottom"> 
        <select id="font-control" name="font-control" v-model="Font" @change="setFont()" :style="{'font-family':Font}" style="height: 35px;width: 194px; outline:none; border:1px solid silver;border-radius:6px;">
            <option v-for="font in fonts" :key="font['font-family']" :value="font['font-family']" :style="{'font-family':font['font-family']}" style="background:white; font-size:20px">{{font['font-family']}}</option>
        </select>
         </vs-tooltip>
        </li>
      <li class="flex">
        <vs-tooltip text="Font Size" position="bottom"> 
           <vs-input-number  v-model="FontSize" @input="setFontSize()" style="width:100px" class="mt-0 pt-0"/>
        </vs-tooltip>
      </li>
      <li> 
         <vs-tooltip text="Alignment" position="bottom">
        <feather-icon v-if="Align==='center'" icon="AlignCenterIcon"  svgClasses="h-8 w-8" @click="changeAlign('right')"/>
        <feather-icon v-else-if="Align==='right'" icon="AlignRightIcon"  svgClasses="h-8 w-8" @click="changeAlign('justify')"/>
        <feather-icon v-else-if="Align==='justify'" icon="AlignJustifyIcon"  svgClasses="h-8 w-8" @click="changeAlign('left')"/>
        <feather-icon v-else icon="AlignLeftIcon"  svgClasses="h-8 w-8" @click="changeAlign('center')"/>
       </vs-tooltip>
      </li>
      <li>
         <!-- <vs-tooltip text="Line Height" position="bottom">
        <input type="number" class="ml-5" step="0.01" min="0.5" max="2.5" v-model="LineHight" @input="changeLineHeight()" style="width:50px; height: 30px;outline:none; border:1px solid silver;border-radius:6px;"/>
          </vs-tooltip> -->
            <vs-tooltip text="Line Height" position="bottom"> 
           <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer ml-3">
              <feather-icon svgClasses="h-6 w-6" icon="LayersIcon"/>


                <vs-dropdown-menu style="z-index: 99999">

                <vs-dropdown-item>
                <vs-slider ticks step="0.1" :min="0.5" :max="3" :step-decimals="true" v-model="LineHight" @change="changeLineHeight"/>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                 </vs-tooltip>
      </li>
      <li> 
         <vs-tooltip text="Text Color" position="bottom">
        <input type="color" id="favcolor" name="favcolor" v-model="FontColor" @input="setFontColor()" value="#ff0000" class="ml-5">
         </vs-tooltip>
      </li>
      
      <li> 
        <vs-tooltip text="Remove Item" position="bottom">
        <feather-icon icon="TrashIcon" class="ml-5 mt-1"  svgClasses="h-5 w-5" @click="removeObj()"/>
        </vs-tooltip>
      </li>
    </ul>
    <ul id="menu" class="flex justify-center items-center m-3" v-if="showRect">
      <li class="flex">
          <label>Border :</label>
           <vs-input-number :is-disabled="true" v-model="BorderWidth" @input="setBorderWidth()" style="width:100px" class="mt-0 pt-0"/>
      </li>
        <li class="flex ml-5"> 
        <label for="font-control ">Border Color :</label>
        <input type="color" id="favcolor" name="favcolor" v-model="BorderColor" @input="setBorderColor()" value="#ff0000" class="ml-5">
      </li>
      <li class="flex ml-5"> 
        <label for="font-control">Background Color :</label>
          <input type="color" id="favcolor" name="favcolor" v-model="BgColor" @input="setBgColor()" value="#ff0000" class="ml-2">
         <img  src="@/assets/images/pages/transparent.png" @click="setBgColorTrans()" class="ml-2 mt-0 pt-0" width="50px" height="20px">
      </li>
       <li> 
        <feather-icon icon="TrashIcon" class="mt-1 ml-5" svgClasses="h-5 w-5" @click="removeObj()"/>
      </li>
    </ul>
    <!-- <vs-row>
      <vs-col class="flex items-center" vs-type="flex" vs-justify="flex-end" vs-w="12">
        <vs-button size="small" icon-pack="feather" icon="icon-image" @click="toggleImageSidebar(true)">Images</vs-button>
      </vs-col>
    </vs-row> -->
  </vs-col>
</vs-row>
  <vs-row >
   <vs-col  vs-w="1" vs-type="flex" vs-justify="center">
     <ul id="sideManu">
       <vs-divider  class="divider-style"></vs-divider>
      <li v-if="dataTemp===false" class="text-center mb-0" @click="ShareTempalte()">
            <vs-tooltip text="Share">
              <share2-icon size="2x" class="custom-class"></share2-icon><br />
            </vs-tooltip>
           <vs-divider class="divider-style"></vs-divider>
      </li>
      <li class="text-center mb-0 vs-con-loading__container"  @click="SaveTempalte()"  id="div-with-loading">
            <vs-tooltip text="Save">
              <save-icon size="2x" class="custom-class"></save-icon><br />
            </vs-tooltip>
           <vs-divider class="divider-style"></vs-divider>
          </li>
      <li class="text-center mb-0" >
            <vs-tooltip text="Add Text" > 
           <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
               <type-icon size="2x" class="custom-class"></type-icon>

                <vs-dropdown-menu style="z-index: 99999">

                 <vs-dropdown-item @click="addHeadText()">
                <span  >
                  <span>Add heading</span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="addSubHeadText()">
                <span class="flex items-center" >
                 <span>Add subheading</span>
                </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item  @click="addParagraphText()">
                <span class="flex items-center">
                  <span>Add paragraph</span>
                </span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                 </vs-tooltip>
         <vs-divider class="divider-style"></vs-divider>
       </li>
       <!-- <li class="text-center mb-0 vs-con-loading__container"  @click="$refs.updateImgNew.click()" id="div-img-loading"> -->
        <li class="text-center mb-0 vs-con-loading__container"  @click="toggleImageSidebar(true)" id="div-img-loading">
        <vs-tooltip text="Add Image" >
        <!-- <input type="file" class="hidden" ref="updateImgNew" @change="updateNewImg" accept="image/*"> -->
        <image-icon size="2x" class="custom-class" @click="toggleImageSidebar(true)"></image-icon><br>
         </vs-tooltip>
        <vs-divider class="divider-style"></vs-divider>
       </li>
       <li class="text-center mb-0" @click="addRect()">
           <vs-tooltip text="Add Rectangle">
        <square-icon size="2x" class="custom-class h-12"></square-icon><br>
          </vs-tooltip>
         <vs-divider class="divider-style"></vs-divider>
       </li>
            <li class="text-center mb-0" @click="QR_PopUp=true">
          <vs-tooltip text="QR Code">
          <img  src="@/assets/images/pages/qr-code.svg" class="responsive w-8 h-8" >
          </vs-tooltip>
          <vs-divider class="divider-style"></vs-divider>
        </li> 
       <li  class="text-center mb-0" >
                  <vs-tooltip text="Export"> 
           <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
               <download-icon size="2x" class="custom-class"></download-icon>
                <vs-dropdown-menu style="z-index: 99999">
                 <vs-dropdown-item>
                <span  class="flex items-center" @click="downloadpdf()">
                  <span>Export PDF</span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="SaveAsJpg()">
                <span>Export JPG</span>
                </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item>
                <span class="flex items-center" @click="SaveAsPng">
                  <span>Export PNG</span>
                </span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                 </vs-tooltip>
        <vs-divider class="divider-style"></vs-divider>
       </li>
       <li class="text-center mb-0" >
            <!-- <vs-tooltip text="Add Text" >  -->
           <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
               <span class="font-bold">JSON</span>

                <vs-dropdown-menu style="z-index: 99999">

                 <vs-dropdown-item>
                <span  @click="canvasTojson()">
                  <span>Export</span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="$refs.jsonTocanvas.click()">
                <input type="file" class="hidden" ref="jsonTocanvas" @change="jsonTocanvas" accept="json">      
                 <span>Import</span>
                </span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                 <!-- </vs-tooltip> -->
         <vs-divider class="divider-style"></vs-divider>
       </li>
     </ul>
   </vs-col>
    <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="11">
      <canvas @click="changeCanv()" ref="canv1" id="canv1" width="900" height="1160"  style="border:2px solid black; border-style: dotted"></canvas>
  </vs-col>
  </vs-row>
     <vs-popup class="holamundo"  title="Choose Template" :active.sync="popupActivo">
      <vs-row vs-w="12">
        <vs-col  vs-justify="center" vs-align="center" vs-w="2" v-for="tr in templates" :key="tr.id" class="ml-10">
      <span >
        <img :src="tr.image" alt="" height="120px" width="100px" style="border:1px solid black; padding: 5px; cursor:pointer" @click="setCanvas(tr)">
        <p class="text-center">{{tr.name}}</p>
      </span>
        </vs-col>
      <vs-col  vs-justify="center" vs-align="center" vs-w="2"  class="ml-10">
      <span >
        <div style=" height:120px;width:100px;cursor:pointer;border: 1px solid black" @click="setCanvas(null)"></div>
        <p class="text-center">Blank</p>
      </span>
        </vs-col>
      </vs-row>


    </vs-popup>
        <vs-popup
      class="holamundo"
      title="Share Newsletter"
      :active.sync="SharePopup"
    >
      <div class="p-6 pt-0">
        <label class="vs-select--label w-full">Select Location *</label>
        <label
          class="ml-5 vs-select--label"
          @click="allLocation"
          style="float: right"
          >Select All</label
        >
        <v-select
          label="name"
          multiple
          @input="getProgram()"
          :closeOnSelect="true"
          v-model="dataLocation"
          :options="locations"
        /><br />
        <label class="vs-select--label w-full">Select Program *</label
        ><label
          class="vs-select--label"
          @click="allProgram"
          style="float: right"
          >Select All</label
        >
        <v-select
          label="name"
          multiple
          @input="getStudent()"
          :closeOnSelect="true"
          v-model="dataProgram"
          :options="programs"
        /><br />
         <label class="vs-select--label w-full">Subject *</label>
        <vs-input class="w-full" v-model="dataSubject"></vs-input><br />
        <label class="vs-select--label w-full">Message *</label>
        <vs-textarea
          label=""
          id="textid"
          v-model="dataMessage"
          name="message"
          v-validate="'required'"
        />
        <div v-if="students.length > 0" class="ml-2 mb-2">
          <input
            type="checkbox"
            @change="SelectAllChip()"
            class="inline-flex"
            v-model="chipcheck"
          />
          <small class="ml-1">Select All</small>
        </div>
        <span v-for="(student, index) in students" :key="index">
          <vs-chip>
            <input type="checkbox" class="mr-5" v-model="student.instant" />
            <vs-avatar v-if="student.image" :src="img_cdn + student.image" />
            <vs-avatar v-else />
            {{ student.fname }} {{ student.lname }}
          </vs-chip>
        </span>
        <div slot="footer" style="float: right" class="mt-5">
          <vs-button
            class="vs-con-loading__container"
            ref="loadableButton"
            id="button-with-loading"
            @click.native="submitData"
            :disabled="!isFormValid"
            >{{ $t("student.add.btn_submit") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
     <vs-popup class="holamundo"  title=" " :active.sync="QR_PopUp">
  <vs-row>        
  <vs-col v-if="qr_link" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
  <vue-qrcode :width="150" :value="Qr_link" ref="QR" />
  </vs-col>
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
    <vs-input class="w-full" v-model="qr_link" placeholder="Enter Link"></vs-input>
    </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
         <vs-button size="small" @click.native="QrSubmit">Create</vs-button>
    </vs-col>
</vs-row>
</vs-popup>
    {{ closepopup }}
  </div>
</template>
<script>
import VueQrcode from 'vue-qrcode'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { fabric } from 'fabric'
import { jsPDF } from 'jspdf'
import { ImageIcon,  DownloadIcon, TypeIcon, UploadIcon, ArrowDownCircleIcon, SquareIcon, SaveIcon, Share2Icon} from 'vue-feather-icons'
import {ADD_NEWSLETTER_TEMPLATE, UPDATE_NEWSLETTER_TEMPLATE, ALL_TEMPLATES_LOAD,
  DROPDOWN_ALL_LOCATIONS,
  GET_PROGRAM_BY_LOCATIONS,
  GET_STUDENT_BY_PROGRAMS_NEWSLETTER,
  MANAGER_LOCATION,
  GET_TEACHER_PROGRAM_BY_LOCATIONS,
  USER_LOCATION,
  CREATE_ALERT_PROGRAM, SEND_NEWSLETTER } from '@/graphql'
import ImageLibrarySidebar from './ImageLibrarySidebar.vue'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  // dirName: process.env.VUE_APP_AWS_DIREC,
  dirName: 'newsletters',
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)
export default {
  components: {
    'image-library-sidebar':ImageLibrarySidebar,
    'image-icon':ImageIcon,
    'download-icon':DownloadIcon,
    'type-icon':TypeIcon,
    'upload-icon':UploadIcon,
    'arrow-down-circle-icon':ArrowDownCircleIcon,
    'square-icon':SquareIcon,
    'save-icon':SaveIcon,
    'share2-icon':Share2Icon,
    'v-select': vSelect,
    VueQrcode
  },
  name: 'temp1',
  data () {
    return {
      ViewSidebar:false,
      dataTemp:false,
      qr_link:null,
      QR_PopUp:false,
      dataId:null,
      dataKey:null,
      dataName:null,
      temp_pdf:null,
      Font:null,
      FontSize:null,
      FontColor:null,
      SelectedItem:'ASdasd',
      Canvas:null,
      showText:false,
      showImg:false,
      showRect:false,
      BorderColor:null,
      BgColor:null,
      BorderWidth:null,   
      SharePopup: false,
      dataMessage: '',
      locations: [],
      programs: [],
      students: [],
      dataLocation: '',
      dataProgram: '',
      btnDisable: true,
      dataInstant: false,
      dataSms: false,
      meRole: '',
      meID: '',
      img_cdn: '',
      chipcheck: true,
      selected: 'student',
      uplodedfiles: [],
      largeFile: [],
      AlertlargeFile: [],
      AlertUplodedfiles: [],
      chatloader: false,
      typeData: 'type_student',
      dataReminder: false,
      dataDate: '',
      dataTime: '',
      configDatePicker: {
        dateFormat: 'm/d/Y'
      },
      configTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      }, 
      fonts:[
        {'font-family': 'Times New Roman'},
        {'font-family': 'Roboto'},
        {'font-family': 'Zilla Slab Highlight'},
        {'font-family': 'Open Sans'},
        {'font-family': 'Spectral'},
        {'font-family': 'Slabo 27px'},
        {'font-family': 'Lato'},
        {'font-family': 'Roboto Condensed'},
        {'font-family': 'Oswald'},
        {'font-family': 'Source Sans Pro'},
        {'font-family': 'Raleway'},
        {'font-family': 'Zilla Slab'},
        {'font-family': 'Montserrat'},
        {'font-family': 'PT Sans'},
        {'font-family': 'Roboto Slab'},
        {'font-family': 'Merriweather'},
        {'font-family': 'Saira Condensed'},
        {'font-family': 'Saira'},
        {'font-family': 'Open Sans Condensed'},
        {'font-family': 'Saira Semi Condensed'},
        {'font-family': 'Saira Extra Condensed'},
        {'font-family': 'Julee'},
        {'font-family': 'Archivo'},
        {'font-family': 'Ubuntu'},
        {'font-family': 'Lora'},
        {'font-family': 'Manuale'},
        {'font-family': 'Asap Condensed'},
        {'font-family': 'Faustina'},
        {'font-family': 'Cairo'},
        {'font-family': 'Playfair Display'},
        {'font-family': 'Noto Sans'},
        {'font-family': 'PT Serif'},
        {'font-family': 'Arimo'},
        {'font-family': 'Titillium Web'},
        {'font-family': 'Sedgwick Ave'},
        {'font-family': 'Indie Flower'},
        {'font-family': 'PT Sans Narrow'},
        {'font-family': 'Bitter'},
        {'font-family': 'Inconsolata'},
        {'font-family': 'Bowlby One SC'},
        {'font-family': 'Arvo'},
        {'font-family': 'Hind'},
        {'font-family': 'Cabin'},
        {'font-family': 'Anton'},
        {'font-family': 'Droid Serif'},
        {'font-family': 'Droid Sans'},
        {'font-family': 'Poppins'},
        {'font-family': 'Muli'},
        {'font-family': 'Mada'},
        {'font-family': 'Noto Serif'},
        {'font-family': 'Dosis'},
        {'font-family': 'Josefin Sans'},
        {'font-family': 'Oxygen'},
        {'font-family': 'Fjalla One'},
        {'font-family': 'Acme'},
        {'font-family': 'Archivo Narrow'},
        {'font-family': 'Mukta Vaani'},
        {'font-family': 'Play'},
        {'font-family': 'Cuprum'},
        {'font-family': 'Maven Pro'},
        {'font-family': 'EB Garamond'},
        {'font-family': 'Passion One'},
        {'font-family': 'Ropa Sans'},
        {'font-family': 'Francois One'},
        {'font-family': 'Archivo Black'},
        {'font-family': 'Pathway Gothic One'},
        {'font-family': 'Exo'},
        {'font-family': 'Vollkorn'},
        {'font-family': 'Libre Franklin'},
        {'font-family': 'Crete Round'},
        {'font-family': 'Alegreya'},
        {'font-family': 'PT Sans Caption'},
        {'font-family': 'Alegreya Sans'},
        {'font-family': 'Source Code Pro'}
      ],
      Align:null,
      LineHight:null,
      popupActivo:false,
      templates:[]
    }
  },
  computed:{
    Qr_link () {
      return this.qr_link
    },
    isFormValid () {
      return (
        !this.errors.any() &&
        this.dataMessage &&
        this.dataLocation &&
        this.dataProgram &&
        this.students &&
        this.btnDisable 
      )
    },
    isFormValidMessage () {
      return !this.errors.any() && this.typedMessage
    },
    closepopup () {
      if (!this.SharePopup) {
        if (this.meRole == 'teacher') {
          this.dataMessage = ''
          this.dataProgram = ''
          this.students = []
          this.btnDisable = true
          this.dataInstant = false
          this.dataSms = false
          this.chipcheck = true
          this.AlertlargeFile = []
          this.AlertUplodedfiles = []
          this.dataReminder = false
          this.dataDate = null
          this.dataTime = null
        } else {
          this.initValues()
        }
      }
    }
  },
  methods:{
    setImg(src){
        const canvas = this.Canvas
        fabric.util.loadImage(src, function (img) {
         console.log(img) 
        const sideImg = new fabric.Image(img)
        sideImg.scaleToWidth(170)
        sideImg.scaleToHeight(170)
        sideImg.left = 20
        sideImg.top = 80
        canvas.add(sideImg)
        canvas.requestRenderAll()
      }, null, {crossOrigin: 'Anonymous'})
       canvas.renderAll()
    },
    toggleImageSidebar (val = false) {
      this.ViewSidebar = val
    },
    QrSubmit () {
      const canvas = this.Canvas
      if (this.qr_link) {
        const img = this.$refs.QR.$el
        fabric.util.loadImage(img.src, function (img) {
          const newImg = new fabric.Image(img)
          newImg.scaleToWidth(160)
          newImg.scaleToHeight(160)
          newImg.left = 20
          newImg.top = 80
          canvas.add(newImg)
        }, null, {crossOrigin: 'Anonymous'})
        canvas.renderAll()
        this.QR_PopUp = false
        this.qr_link = null

      } else {
        this.$vs.notify({
          title: 'Newsletter',
          text: 'QR Link is Required',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    ShareTempalte () {
      this.SaveTempalteBefore()
      // this.SharePopup = true
    },
    setCanvas (temp) {
      if (temp) {
        this.popupActivo = false
        const canvas = this.Canvas  
        canvas.loadFromJSON(temp.template, canvas.renderAll.bind(canvas))
      } else {
        this.popupActivo = false
      }
    },
    changeLineHeight () {
      const canvas = this.Canvas
      if (this.LineHight && canvas.getActiveObject()) {
        canvas.getActiveObject().set('lineHeight', this.LineHight)
        canvas.requestRenderAll()
      }
    },
    changeAlign (direction) {
      this.Align = direction
      const canvas = this.Canvas
      if (this.Align && canvas.getActiveObject()) {
        canvas.getActiveObject().set('textAlign', this.Align)
        canvas.requestRenderAll()
      }
    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'Newsletter',
        text: 'Saved Successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    SendStatusSuccess (msg) {
      this.$vs.notify({
        title: 'Newsletter',
        text: msg,
        color: 'success',
        position: 'top-right'
      })
    },
    openLoadingContainedSave () {
      this.$vs.loading({
        background: '#F8F8F8',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    openLoadingContained () {
      this.$vs.loading({
        container: this.$refs.loadableButton.$el,
        scale: 0.45
      })
    }, 
    openLoadingForImg () {
      this.$vs.loading({
        background: '#F8F8F8',
        container: '#div-img-loading',
        scale: 0.6
      })
    },
    openLoadingForChangeImg () {
      this.$vs.loading({
        background: '#F8F8F8',
        container: '#div-changeimg-loading',
        scale: 0.6
      })
    },
    saveFile (file, oldfileName, jsondata) {
      S3Client.uploadFile(file, oldfileName, jsondata)
        .then((response) => {
          console.log(response)
          this.$apollo
            .mutate({
              mutation: UPDATE_NEWSLETTER_TEMPLATE,
              variables: {
                id:this.dataId,  
                template:JSON.stringify(jsondata),
                name:this.dataName,  
                is_temp:this.dataTemp,
                image:response.location
              }
            })
            .then(response => {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              if (response.data.updateNewsletterTemplate.status == 'Success') {
                this.StatusSuccess(response.data.updateNewsletterTemplate.message)
              }
            }).catch(error => {
              console.log(error)
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    saveNewFile (file, fileName, jsondata) {
      S3Client.uploadFile(file, fileName)
        .then((response) => {
          console.log(response)
          this.$apollo
            .mutate({
              mutation: ADD_NEWSLETTER_TEMPLATE,
              variables: {
                name:  this.dataName,
                template:JSON.stringify(jsondata),
                image: response.location,
                key:fileName.substring(1),
                is_temp:this.dataTemp
              }
            })
            .then(response => {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              if (response.data.addNewsletterTemplate.status === 'Success') {
                this.dataId = response.data.addNewsletterTemplate.id
                this.dataKey = response.data.addNewsletterTemplate.key

                this.StatusSuccess()
              }
            }).catch(error => {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              console.log(error)
            })
        })
        .catch((err) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          console.error(err)
        })
    }, 
    async SaveTempalte () {
      if (this.dataName) {
        this.openLoadingContainedSave()
        const canvas = this.Canvas  
        const jsondata = canvas.toJSON()
        const fileString = canvas.toDataURL(
          {
            format: 'jpeg'
          }
        )
        function resizedataURL (datas, wantedWidth, wantedHeight) {
          return new Promise(async function (resolve, reject) {

            // We create an image to receive the Data URI
            const img = document.createElement('img')
            // When the event "onload" is triggered we can resize the image.
            img.onload = function () {        
            // We create a canvas and get its context.
              const newcanvas = document.createElement('canvas')
              const ctx = newcanvas.getContext('2d')

              // We set the dimensions at the wanted size.
              newcanvas.width = wantedWidth
              newcanvas.height = wantedHeight

              // We resize the image with the canvas method drawImage();
              ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight)

              const dataURI = newcanvas.toDataURL('image/jpeg')

              // This is the return of the Promise
              resolve(dataURI)
            }

            // We put the Data URI in the image's src attribute
            img.src = datas

          })   
        } 
        const new_fileString = await resizedataURL(fileString, 200, 250) 
        function dataURLtoFile (dataurl, filename) {
          let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          return new File([u8arr], filename, { type: mime })
        }
        if (this.dataId !== null && this.dataId >= 0) {
          const oldfileName = this.dataKey
          const file = dataURLtoFile(fileString, oldfileName)
          const newfile = dataURLtoFile(new_fileString, `S${  oldfileName}`)
          this.saveFile(newfile, `S${  oldfileName}`, jsondata)
          this.UploadAWS(file, oldfileName)


          const cwidth = canvas.width / 1.5
          const cheight = canvas.height / 1.5
          let orientation = 'l'
          if (cheight > cwidth) orientation = 'p'
          const pdf = new jsPDF(orientation, 'px', [cwidth, cheight], {hotfixes: ['px_scaling']})
          const width = pdf.internal.pageSize.width
          const height = pdf.internal.pageSize.height
          const img = canvas.toDataURL('image/jpeg')
          pdf.addImage(img, 'jpeg', 0, 0, width, height)
          const pdffile = dataURLtoFile(pdf.output('datauristring'), `P${oldfileName}`)
          this.UploadAWS(pdffile, `P${  oldfileName}`)
        } else {   
          const today = new Date()
          const date = `${today.getMonth() + 1}-${today.getDate()}-${today.getFullYear()}`
          const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
          const fileName = `${time}-${date}` + 'Newsletter'
          const file = dataURLtoFile(fileString, fileName)
          const newfile = dataURLtoFile(new_fileString, `S${  fileName}`)
          this.saveNewFile(newfile, `S${  fileName}`, jsondata)
          this.UploadAWS(file, fileName)
          const cwidth = canvas.width / 1.5
          const cheight = canvas.height / 1.5
          let orientation = 'l'
          if (cheight > cwidth) orientation = 'p'
          const pdf = new jsPDF(orientation, 'px', [cwidth, cheight], {hotfixes: ['px_scaling']})
          const width = pdf.internal.pageSize.width
          const height = pdf.internal.pageSize.height
          const img = canvas.toDataURL('image/jpeg')
          pdf.addImage(img, 'jpeg', 0, 0, width, height)
          const pdffile = dataURLtoFile(pdf.output('datauristring'), `P${fileName}`)
          this.UploadAWS(pdffile, `P${  fileName}`)
        }
      } else {
        this.$vs.notify({
          title: 'Newsletter',
          text: 'Name is Required',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    UploadAWS (file, name) {
      S3Client.uploadFile(file, name)
        .then((response) => {
          console.log(response)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async  SaveTempalteBefore () {
      if (this.dataName) {
        this.openLoadingContainedSave()
        const canvas = this.Canvas  
        const jsondata = canvas.toJSON()
        const fileString = canvas.toDataURL(
          {
            format: 'jpeg'
          }
        )
        function resizedataURL (datas, wantedWidth, wantedHeight) {
          return new Promise(async function (resolve, reject) {

            // We create an image to receive the Data URI
            const img = document.createElement('img')
            // When the event "onload" is triggered we can resize the image.
            img.onload = function () {        
            // We create a canvas and get its context.
              const newcanvas = document.createElement('canvas')
              const ctx = newcanvas.getContext('2d')

              // We set the dimensions at the wanted size.
              newcanvas.width = wantedWidth
              newcanvas.height = wantedHeight

              // We resize the image with the canvas method drawImage();
              ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight)

              const dataURI = newcanvas.toDataURL('image/jpeg')

              // This is the return of the Promise
              resolve(dataURI)
            }

            // We put the Data URI in the image's src attribute
            img.src = datas

          })   
        } 
        const new_fileString = await resizedataURL(fileString, 200, 250) 
        function dataURLtoFile (dataurl, filename) {
          let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          return new File([u8arr], filename, { type: mime })
        }
        if (this.dataId !== null && this.dataId >= 0) {
          const oldfileName = this.dataKey
          const file = dataURLtoFile(fileString, oldfileName)
          const newfile = dataURLtoFile(new_fileString, `S${  oldfileName}`)
          this.saveFile(newfile, `S${  oldfileName}`, jsondata)
          this.UploadAWS(file, oldfileName)

          const cwidth = canvas.width / 1.5
          const cheight = canvas.height / 1.5
          let orientation = 'l'
          if (cheight > cwidth) orientation = 'p'
          const pdf = new jsPDF(orientation, 'px', [cwidth, cheight], {hotfixes: ['px_scaling']})
          const width = pdf.internal.pageSize.width
          const height = pdf.internal.pageSize.height
          const img = canvas.toDataURL('image/jpeg')
          pdf.addImage(img, 'jpeg', 0, 0, width, height)
          const pdffile = dataURLtoFile(pdf.output('datauristring'), `P${oldfileName}`)
          this.UploadAWS(pdffile, `P${  oldfileName}`)
          this.SharePopup = true
        } else {   
          const today = new Date()
          const date = `${today.getMonth() + 1}-${today.getDate()}-${today.getFullYear()}`
          const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
          const fileName = `${time}-${date}` + 'Newsletter'
          const file = dataURLtoFile(fileString, fileName)
          const newfile = dataURLtoFile(new_fileString, `S${  fileName}`)
          this.saveNewFile(newfile, `S${  fileName}`, jsondata)
          this.UploadAWS(file, fileName)
          const cwidth = canvas.width / 1.5
          const cheight = canvas.height / 1.5
          let orientation = 'l'
          if (cheight > cwidth) orientation = 'p'
          const pdf = new jsPDF(orientation, 'px', [cwidth, cheight], {hotfixes: ['px_scaling']})
          const width = pdf.internal.pageSize.width
          const height = pdf.internal.pageSize.height
          const img = canvas.toDataURL('image/jpeg')
          pdf.addImage(img, 'jpeg', 0, 0, width, height)
          const pdffile = dataURLtoFile(pdf.output('datauristring'), `P${fileName}`)
          this.UploadAWS(pdffile, `P${  fileName}`)
          this.SharePopup = true
        }
      } else {
        this.$vs.notify({
          title: 'Newsletter',
          text: 'Name is Required',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    SaveAsJpg () {    
      function dataURLtoBlob (dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], {type:mime})
      }
      const canvas = this.Canvas  
      const link = document.createElement('a')
      const imgData = canvas.toDataURL({format: 'jpg', multiplier: 4})
      const blob = dataURLtoBlob(imgData)
      const objurl = URL.createObjectURL(blob)

      link.download = 'canvas.jpg'

      link.href = objurl

      link.click()
    },
    SaveAsPng () {  
      function dataURLtoBlob (dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], {type:mime})
      }
      const canvas = this.Canvas  
      const link = document.createElement('a')
      const imgData = canvas.toDataURL({format: 'png', multiplier: 4})
      const blob = dataURLtoBlob(imgData)
      const objurl = URL.createObjectURL(blob)

      link.download = 'canvas.png'

      link.href = objurl

      link.click()
    },
    getCanvasActiveObject () {
      const canvas = this.Canvas  
      if (canvas.getActiveObject()) {
        this.FontSize = null
        this.Font = null
        this.FontColor = null
        this.BorderWidth = null
        this.BorderColor = null
        this.BgColor = null
        if (canvas.getActiveObject().get('type') === 'textbox') {
          this.showText = true
          this.showImg = false
          this.showRect = false
          this.FontSize = canvas.getActiveObject().fontSize
          this.Font = canvas.getActiveObject().fontFamily
          this.FontColor = canvas.getActiveObject().fill
          this.Align = canvas.getActiveObject().textAlign
          this.LineHight = canvas.getActiveObject().lineHeight
        }
        if (canvas.getActiveObject().get('type') === 'image') {
          this.showText = false
          this.showImg = true
          this.showRect = false
        }
        if (canvas.getActiveObject().get('type') === 'rect') {
          this.showRect = true
          this.showText = false
          this.showImg = false
          this.BorderWidth = canvas.getActiveObject().strokeWidth
          this.BorderColor = canvas.getActiveObject().stroke
          this.BgColor = canvas.getActiveObject().fill
        }
      } else {
        this.showRect = false
        this.showText = false
        this.showImg = false
      }
    },
    jsonTocanvas (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          const contents = e.target.result
          const json = JSON.parse(contents)
          const canvas = this.Canvas  
          canvas.loadFromJSON(json, canvas.renderAll.bind(canvas))
        }
        reader.readAsText(input.target.files[0]) 
      }    
    },
    canvasTojson () {
      const canvas = this.Canvas  
      const json = canvas.toJSON()
      const a = document.createElement('a')
      const file = new Blob([JSON.stringify(json)], {
        type: 'text/plain'
      })
      a.href = URL.createObjectURL(file)
      a.download = 'canvastojson.json'
      a.click()
    },
    removeObj () {
      const canvas = this.Canvas
      canvas.remove(canvas.getActiveObject())
    },
    addHeadText () {
      const canvas = this.Canvas
      const Titletext = new fabric.Textbox('Heading', { 
        fontWeight:'bold',
        fontSize:56,
        fill:'#000000'
      })
      canvas.add(Titletext)
      canvas.renderAll()

    },
    addSubHeadText () {
      const canvas = this.Canvas
      const subTitletext = new fabric.Textbox('Add subheading', { 
        fontSize:32,
        fill:'#000000',
        width: 300
      })
      canvas.add(subTitletext)
      canvas.renderAll()

    },
    addParagraphText () {
      const canvas = this.Canvas
      const Paragraphtext = new fabric.Textbox('Add a little bit of body', { 
        fontSize:22,
        fill:'#000000',
        fontWeight:'normal',
        width: 300

      })
      canvas.add(Paragraphtext)
      canvas.renderAll()

    },
    addRect () {
      const canvas = this.Canvas
      const new_rect = new fabric.Rect({
        left: 20,
        top: 20,
        fill:'transparent',
        width: 100,
        height: 200,
        stroke: '#00c2cb',
        strokeWidth: 5,
        rx: 5,
        ry: 5
      })
      canvas.add(new_rect)

    },
    setFontColor () {
      const canvas = this.Canvas
      if (this.FontColor && canvas.getActiveObject()) {
        canvas.getActiveObject().set('fill', this.FontColor)
        canvas.requestRenderAll() 
      }
    },
    setFont () {
      const canvas = this.Canvas
      if (this.Font && canvas.getActiveObject()) {
        canvas.getActiveObject().set('fontFamily', this.Font)
        canvas.requestRenderAll() 
      }
    },
    setFontSize () {
      const canvas = this.Canvas
      if (this.FontSize && canvas.getActiveObject()) {
        canvas.getActiveObject().set('fontSize', this.FontSize)
        canvas.requestRenderAll() 
      }
    },
    setBorderWidth () {
      const canvas = this.Canvas
      if (this.BorderWidth && canvas.getActiveObject()) {
        const currObj = canvas.getActiveObject()
        // canvas.getActiveObject().set("strokeWidth", );
        const newWidth = currObj.width * currObj.scaleX,
          newHeight = currObj.height * currObj.scaleY
        currObj.set({
          'width': newWidth,
          'height': newHeight,
          'scaleX': 1,
          'scaleY': 1,
          'strokeWidth':parseInt(this.BorderWidth)
        })
      }
      canvas.renderAll()
    },
    setBorderColor () {
      const canvas = this.Canvas
      if (this.BorderColor && canvas.getActiveObject()) {
        canvas.getActiveObject().set('stroke', this.BorderColor)
        canvas.requestRenderAll() 
      }
    },
    setBgColor () {
      const canvas = this.Canvas
      if (this.BgColor && canvas.getActiveObject()) {
        canvas.getActiveObject().set('fill', this.BgColor)
        canvas.requestRenderAll() 
      }
    },
    setBgColorTrans () {
      const canvas = this.Canvas
      if (this.BgColor && canvas.getActiveObject()) {
        canvas.getActiveObject().set('fill', 'transparent')
        canvas.requestRenderAll() 
      }
    },
    updateCurrImg (input) {
      this.openLoadingForChangeImg()
      const canvas = this.Canvas
      const file = this.$refs.updateImgInput.files[0]
      const name = Math.random().toString().slice(2)
      S3Client
        .uploadFile(file, name)
        .then(response => {
          console.log(response)
          const left = canvas.getActiveObject().left
          const top = canvas.getActiveObject().top
          fabric.util.loadImage(response.location, function (img) {
            const oimg = new fabric.Image(img)
            oimg.top = top
            oimg.left = left
            canvas.add(oimg)
            canvas.renderAll()
          }, null, {crossOrigin: 'Anonymous'})
          canvas.renderAll()
          canvas.remove(canvas.getActiveObject())
          this.$vs.loading.close('#div-changeimg-loading > .con-vs-loading')
        })
        .catch(err => console.error(err))
    },
    updateNewImg (input) {
      this.openLoadingForImg()
      const canvas = this.Canvas
      const file = this.$refs.updateImgNew.files[0]
      const name = Math.random().toString().slice(2)
      S3Client
        .uploadFile(file, name)
        .then(response => {
          console.log(response)
          fabric.util.loadImage(response.location, function (img) {
            const oimg = new fabric.Image(img)
            canvas.add(oimg)
          }, null, {crossOrigin: 'Anonymous'})
          canvas.renderAll()
          this.$vs.loading.close('#div-img-loading > .con-vs-loading')
        })
        .catch(err => console.error(err))
      // if (input.target.files && input.target.files[0]) {
      //   const reader = new FileReader()
      //   reader.onload = e => {       
      //     fabric.util.loadImage(e.target.result, function (img) {
      //       const newImg = new fabric.Image(img)
      //       newImg.scaleToWidth(160)
      //       newImg.scaleToHeight(160)
      //       newImg.left = 20
      //       newImg.top = 80
      //       canvas.add(newImg)
      //     }, null, {crossOrigin: 'Anonymous'})
      //     canvas.renderAll()
      //   }
      //   reader.readAsDataURL(input.target.files[0])
      // }
    },
    downloadpdf () {
      const canvas = this.temp_pdf
      //   only jpeg is supported by jsPDF
      const currentTime = new Date()
      const month = currentTime.getMonth() + 1
      const day = currentTime.getDate()
      const year = currentTime.getFullYear()
      const hours = currentTime.getHours()
      const minutes = currentTime.getMinutes()
      const seconds = currentTime.getSeconds()
      const origfileName = `${month  }${  day  }${  year  }${  hours  }${  minutes  }${  seconds}`
      let fileName = ''  
      const cwidth = canvas.width / 1.5
      const cheight = canvas.height / 1.5
      let orientation = 'l'
      if (cheight > cwidth) orientation = 'p'

      setTimeout(function () {
        const pdf = new jsPDF(orientation, 'px', [cwidth, cheight], {hotfixes: ['px_scaling']})
        const width = pdf.internal.pageSize.width
        const height = pdf.internal.pageSize.height
        const img = canvas.toDataURL('image/jpeg')
        pdf.addImage(img, 'jpeg', 0, 0, width, height)
        fileName = `${origfileName  }.pdf`
        pdf.save(fileName)
      }, 10)          
      //    setTimeout(function() {
      //         // var pdf = new jsPDF({hotfixes: ["px_scaling"]});
      //        var pdf = new jsPDF();
      //        var img = canvas.toDataURL('image/JPEG');
      //          pdf.addImage(img,'JPEG',0,0,);
      //         fileName = origfileName + ".pdf";
      //         pdf.save(fileName);
      // }, 10);
    },
    createCanvas () {
      const ref = this.$refs.canv1
      const canvas = new fabric.Canvas(ref, {backgroundColor : 'white'})
      // fabric.util.loadImage('https://kvadmin01.s3.us-east-2.amazonaws.com/fabric_images/head.PNG', function (img) {
      //   const headimg = new fabric.Image(img)
      //   headimg.scaleToWidth(200)
      //   headimg.scaleToHeight(90)
      //   headimg['name'] = 'head'
      //   headimg['id'] = 1
      //   canvas.add(headimg)
      // }, null, {crossOrigin: 'Anonymous'})
    

      // fabric.util.loadImage('https://kvadmin01.s3.us-east-2.amazonaws.com/fabric_images/heart.PNG', function (img) {
      //   const sideImg = new fabric.Image(img)
      //   sideImg.scaleToWidth(170)
      //   sideImg.scaleToHeight(170)
      //   sideImg.left = 20
      //   sideImg.top = 80
      //   sideImg['name'] = 'heart'
      //   sideImg['id'] = 2
      //   canvas.add(sideImg)
      // }, null, {crossOrigin: 'Anonymous'})
      // const Titletext = new fabric.Textbox('LaffyTaffies', { 
      //   fontFamily: 'Rouge Script',
      //   left: 300, 
      //   top: 60,
      //   width: 800,
      //   fill:'#FF83A8',
      //   fontSize: 130
      // })
      // canvas.add(Titletext)
      // const year_text = new fabric.Textbox('NEWSLETTER | FEBRUARY 2021', { 
      //   fontFamily:'Ubuntu',
      //   left: 280, 
      //   top: 235,
      //   width: 700,
      //   fill:'#00c2cb',
      //   fontSize: 40,
      //   fontWeight: 'bold'
      // })
      // canvas.add(year_text)
      // const rect1 = new fabric.Rect({
      //   left: 20,
      //   top: 285,
      //   fill:'transparent',
      //   width: 430,
      //   height: 600,
      //   strokeWidth: 5, 
      //   stroke: '#00c2cb',
      //   rx: 5,
      //   ry: 5
      // })
      // canvas.add(rect1)
      // const rect1_h = new fabric.Textbox('-THE SWEET SCOOP-', { 
      //   left: 90, 
      //   top: 290,
      //   width: 400,
      //   fill:'#FF83A8',
      //   fontSize: 30
      // })
      // canvas.add(rect1_h)
      // var rect1_p = new fabric.Textbox('This area should be reserved for overview of what\'s going on at the center this month. Or, important, notices about paperwork, information, etc. Sometimes owners prefer to leave a message to their parents in this area. You will leave a note here for your parents This is a messaging area for you to write important details. This area should be reserved for overview of what\'s going on at the center this month. Or, important, notices about paperwork, information, etc. Save this area fornotices and other important details parents need.', { 
      //   left: 50, 
      //   top: 330,
      //   width: 380,
      //   fill:'#808080',
      //   fontSize: 21
      // })
      // canvas.add(rect1_p)  
      // var rect1_p = new fabric.Textbox('Sandy Christman', { 
      //   left: 180, 
      //   top: 840,
      //   width: 350,
      //   fill:'#FF83A8',
      //   fontSize: 30
      // })
      // canvas.add(rect1_p)   
      // const rect2 = new fabric.Rect({
      //   left: 470,
      //   top: 285,
      //   fill:'transparent',
      //   width: 410,
      //   height: 290,
      //   strokeWidth: 5, 
      //   stroke: '#FF83A8',
      //   rx: 5,
      //   ry: 5
      // })
      // canvas.add(rect2)
      // const rect2_h = new fabric.Textbox('-REMINDERS-', { 
      //   left: 580, 
      //   top: 290,
      //   width: 700,
      //   fill:'#00c2cb',
      //   fontSize: 30
      // })
      // canvas.add(rect2_h)
      // const rect2_p = new fabric.Textbox('Leave this area for reminders and important notices about special things not included in Sandy\'s monthly overview of things. Maybe include deadlines price increases, etc. Or, you may want to advertise openings in certain rooms.', { 
      //   left: 500, 
      //   top: 330,
      //   width: 350,
      //   fill:'#808080',
      //   fontSize: 21
      // })
      // canvas.add(rect2_p) 
      // const rect3 = new fabric.Rect({
      //   left: 470,
      //   top: 600,
      //   fill:'transparent',
      //   width: 410,
      //   height: 280,
      //   strokeWidth: 5, 
      //   stroke: '#fcaf25',
      //   rx: 5,
      //   ry: 5
      // })
      // canvas.add(rect3)
      // const rect3_h = new fabric.Textbox('-EVENTS-', { 
      //   left: 600, 
      //   top: 610,
      //   width: 700,
      //   fill:'#00c2cb',
      //   fontSize: 30,
      //   fontWeight: 'bold'
      // })
      // canvas.add(rect3_h)
      // const rect3_p = new fabric.Textbox('2/12/21 - Valentine\'s Parties 2/15/21 - Closed for Pres Day 2/16/21 - Mardi Gras Crafts 2/18/21 - Pajama Day 2/21/21 - Book Fair 2/26/21 - Fairytale Day', { 
      //   left: 500, 
      //   top: 650,
      //   width: 350,
      //   fill:'#808080',
      //   fontSize: 22
      // })
      // canvas.add(rect3_p) 
      // const rect4 = new fabric.Rect({
      //   left: 20,
      //   top: 910,
      //   fill:'transparent',
      //   width: 430,
      //   height: 190,
      //   strokeWidth: 5, 
      //   stroke: '#FF83A8',
      //   rx: 5,
      //   ry: 5
      // })
      // canvas.add(rect4)
      // const rect4_h = new fabric.Textbox('-CONTACT INFO-', { 
      //   left: 120, 
      //   top: 920,
      //   width: 700,
      //   fill:'#FF83A8',
      //   fontSize: 30
      // })
      // canvas.add(rect4_h)
      // var rect4_p = new fabric.Textbox('471 Constitution Blvd Box Elder, SD 57719 (605) 791-1232 www.candylandchildcare.com', { 
      //   left: 150, 
      //   top: 960,
      //   width: 280,
      //   fill:'#808080',
      //   fontSize: 21
      // })
      // canvas.add(rect4_p) 
      // var rect4_p = new fabric.Textbox('info@candylandchildcare.com', { 
      //   left: 130, 
      //   top: 1073,
      //   width: 250,
      //   fill:'#000000',
      //   fontSize: 21,
      //   fontWeight: 'bold'
      // })
      // canvas.add(rect4_p) 

      // fabric.util.loadImage('https://kvadmin01.s3.us-east-2.amazonaws.com/fabric_images/candyland.png', function (img) {
      //   const logo_img = new fabric.Image(img)
      //   logo_img.scaleToWidth(220)
      //   logo_img.scaleToHeight(220)
      //   logo_img.left = 530
      //   logo_img.top = 900
      //   logo_img['name'] = 'logo'
      //   logo_img['id'] = 3
      //   canvas.add(logo_img)
      // }, null, {crossOrigin: 'Anonymous'})
     
      // fabric.util.loadImage('https://kvadmin01.s3.us-east-2.amazonaws.com/fabric_images/spiner.png', function (img) {
      //   const rect1_Img = new fabric.Image(img)
      //   rect1_Img.scaleToWidth(80)
      //   rect1_Img.scaleToHeight(80)
      //   rect1_Img.left = 25
      //   rect1_Img.top = 800
      //   rect1_Img['name'] = 'rect1_Img'
      //   rect1_Img['id'] = 4
      //   canvas.add(rect1_Img)
      // }, null, {crossOrigin: 'Anonymous'})
     
      // fabric.util.loadImage('https://kvadmin01.s3.us-east-2.amazonaws.com/fabric_images/qr.PNG', function (img) {
      //   const qr_Img = new fabric.Image(img)
      //   qr_Img.scaleToWidth(100)
      //   qr_Img.scaleToHeight(100)
      //   qr_Img.left = 40
      //   qr_Img.top = 960
      //   qr_Img['name'] = 'qr_Img'
      //   qr_Img['id'] = 5
      //   canvas.add(qr_Img)
      // }, null, {crossOrigin: 'Anonymous'})
      // canvas.renderAll()
      this.temp_pdf = canvas
      this.Canvas = canvas
    },
    getTemplate () {
      this.$apollo
        .mutate({
          mutation: ALL_TEMPLATES_LOAD
        })
        .then(response => {
          this.templates = response.data.loadtemplates
          if (this.templates.length > 0) {
            this.popupActivo = true
          }
        })
    },
    submitData () {
      // function dataURLtoFile (dataurl, filename) {
      //   let arr = dataurl.split(','),
      //     mime = arr[0].match(/:(.*?);/)[1],
      //     bstr = atob(arr[1]),
      //     n = bstr.length,
      //     u8arr = new Uint8Array(n)
      //   while (n--) {
      //     u8arr[n] = bstr.charCodeAt(n)
      //   }
      //   return new File([u8arr], filename, { type: mime })
      // }
      const canvas = this.Canvas
      const img = canvas.toDataURL('image/png')
      // const file = dataURLtoFile(img, 'Newsletter')

      // const cwidth = canvas.width / 1.5
      // const cheight = canvas.height / 1.5
      // let orientation = 'l'
      // if (cheight > cwidth) orientation = 'p'
      // const pdf = new jsPDF(orientation, 'px', [cwidth, cheight], {hotfixes: ['px_scaling']})
      // const width = pdf.internal.pageSize.width
      // const height = pdf.internal.pageSize.height
      // const imgpdf = canvas.toDataURL('image/jpeg')
      // pdf.addImage(imgpdf, 'jpeg', 0, 0, width, height)
      // const pdfString = pdf.output('datauristring')
      //  const file = dataURLtoFile(pdf.output('datauristring'), "Newsletter")
      this.btnDisable = false
      this.openLoadingContained()
      if (this.typeData === 'type_student') {
        const lastusers = []
        const laststudent = []
        if (this.students.length > 0) {
          for (let i = 0; i < this.students.length; i++) {
            if (this.students[i].instant) {
              laststudent.push(this.students[i].id)
              for (let j = 0; j < this.students[i].users.length; j++) {
                if (
                  this.students[i].users[j].email
                ) {
                  lastusers.push(this.students[i].users[j])
                }
              }
            }
          }
        }
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$apollo
              .mutate({
                mutation: SEND_NEWSLETTER,
                variables: {
                  newsletter_id:this.dataId,
                  sub:this.dataSubject,
                  msg: this.dataMessage,
                  users: lastusers,
                  img
                }
              })
              .then((response) => {
                if (response) {
                  this.$vs.loading.close(this.$refs.loadableButton.$el)
                  this.btnDisable = true
                  if (response.data.sendNewsletter.status === 'Success') {
                    this.SendStatusSuccess(response.data.sendNewsletter.message)
                    this.$router.push('/newsletters')
                    this.initValues()
                  }
                }
                this.closeAlertPopup()
              })
              .catch((error) => {
                this.$vs.loading.close(this.$refs.loadableButton.$el)
                this.btnDisable = true
                this.closeAlertPopup()
                this.$router.push('/newsletters')
              })
          }
        })
      }
      function dataURLtoFile (dataurl, filename) {
        let arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
      }
    },
    SelectAllChip () {
      if (this.chipcheck) {
        for (let index = 0; index < this.students.length; index++) {
          this.students[index].instant = true
        }
      } else {
        for (let index = 0; index < this.students.length; index++) {
          this.students[index].instant = false
        }
      }
    },
    allLocation () {
      if (this.dataLocation.length === this.locations.length) {
        this.dataLocation = []
      } else {
        this.dataLocation = this.locations
      }
      this.getProgram()
    },
    allProgram () {
      if (this.dataProgram.length === this.programs.length) {
        this.dataProgram = []
      } else {
        this.dataProgram = this.programs
      }
      this.getStudent()
    },
    getProgram () {
      this.students = []
      this.programs = []
      this.dataProgram = ''
      const locations = []
      if (this.dataLocation.length > 0) {
        for (let i = 0; i < this.dataLocation.length; i++) {
          locations.push(this.dataLocation[i].id)
        }
        if (this.meRole == 'teacher') {
          this.$apollo
            .mutate({
              mutation: GET_TEACHER_PROGRAM_BY_LOCATIONS,
              variables: {
                teacher_id: this.meID,
                location_id: locations
              }
            })
            .then((response) => {
              if (response) {
                for (
                  let index = 0;
                  index < response.data.teacher_locations_programs.length;
                  index++
                ) {
                  this.programs.push(
                    response.data.teacher_locations_programs[index]
                  )
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.$apollo
            .mutate({
              mutation: GET_PROGRAM_BY_LOCATIONS,
              variables: {
                location_id: locations
              }
            })
            .then((response) => {
              if (response) {
                for (
                  let index = 0;
                  index < response.data.locations_programs.length;
                  index++
                ) {
                  this.programs.push(response.data.locations_programs[index])
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    validEmail (value) {
      if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
        return false
      } else {
        return true
      }
    },
    getStudent () {
      if (this.typeData === 'type_student') {
        this.dataSms = false
        this.dataInstant = false
        this.students = []
        const program = []
        if (this.dataProgram.length > 0) {
          for (let i = 0; i < this.dataProgram.length; i++) {
            program.push(this.dataProgram[i].id)
          }
          this.$apollo
            .mutate({
              mutation: GET_STUDENT_BY_PROGRAMS_NEWSLETTER,
              variables: {
                program_id: program
              }
            })
            .then((response) => {
              if (response) {
                const filterUser = []
                const listStudent = response.data.programsStudentNewletter
                // this.students = listStudent
                if (listStudent.length > 0) {
                  for (let i = 0; i < listStudent.length; i++) {
                    listStudent[i].instant = true
                    if (listStudent[i].users.length > 0) {
                      const listusers = []
                      for (let j = 0; j < listStudent[i].users.length; j++) {
                        const user = listStudent[i].users[j]
                        if (this.validEmail(user.email) === true && user.invited === false && user.pending === false) {
                          if (filterUser.indexOf(user.id) == -1) {
                            filterUser.push(user.id)
                            listusers.push(user)
                          } else {
                            listusers.push(user)
                          }
                        }
                      }

                      listStudent[i].users = listusers
                    }
                    if (listStudent[i].users.length > 0) {
                      this.students.push(listStudent[i])
                    }
                  }
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    closeAlertPopup () {
      this.SharePopup = false
    },
    initValues () {
      this.dataLocation = ''
      this.dataMessage = ''
      this.dataProgram = ''
      this.programs = []
      this.students = []
      this.btnDisable = true
      this.dataInstant = false
      this.dataSms = false
      this.chipcheck = true
      this.AlertlargeFile = []
      this.AlertUplodedfiles = []
      this.typeData = 'type_student'
      this.dataReminder = false
      this.dataDate = null
      this.dataTime = null
    },
    getdata () {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.meRole = userRole
      this.meID = userId
      this.conditionMethod(userRole,userId)
    },
    conditionMethod (role, id) {
      if (role === 'manager') {
        this.$apollo
          .mutate({
            mutation: MANAGER_LOCATION,
            variables: {
              id
            }
          })
          .then((response) => {
            this.locations = response.data.user.managerlocations
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (role === 'teacher') {
        this.$apollo
          .mutate({
            mutation: USER_LOCATION,
            variables: {
              id
            }
          })
          .then((response) => {
            this.locations = response.data.user.locations
            this.allLocation()
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.$apollo
          .mutate({
            mutation: DROPDOWN_ALL_LOCATIONS
          })
          .then((response) => {
            this.locations = response.data.dropdownlocations
          })
      }
    }
  },
  mounted () {
    this.createCanvas()
    const header = document.getElementById('myHeader')
    const sideManu = document.getElementById('sideManu')
    const sticky = header.offsetTop
    function myFunction () {
      if (window.pageYOffset > sticky) {
        header.classList.add('sticky')
        sideManu.classList.add('stickySide')
      } else {
        header.classList.remove('sticky')
        sideManu.classList.remove('stickySide')
      }
    }
    window.onscroll = function () { myFunction() }
    if (this.$store.getters.getNewsletterJson) {
      const canvas = this.Canvas
      canvas.loadFromJSON(this.$store.getters.getNewsletterJson, canvas.renderAll.bind(canvas))
      this.$store.dispatch('setNewsletterJson', null)
    }
  },
  created () {
    if (this.$store.getters.getNewsletterJson === null) {
      this.getTemplate()
    }
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.interval = setInterval(() => this.getCanvasActiveObject(), 1000)
    if (this.$route.params.is_temp === 'temp') {
      this.dataTemp = true
    } else {
      this.dataTemp = false
      this.getdata()
    }
    const d = new Date()
    this.dataName = `${d.toLocaleString('default', { month: 'long' })} ${d.getFullYear()}`
    this.dataSubject =  `${d.toLocaleString('default', { month: 'long' })} ${d.getFullYear()}`
  }

}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Rouge+Script&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Ubuntu&display=swap');
#canv1{
    background-color: #FFFFFF;
}
canvas {
    display:block;
}

body {
    margin:0;
}
 ul#sideManu {
   position: fixed;
    cursor: pointer;
    display:inline;
    margin: 5px;
    cursor: pointer;
    margin-top: 0;
    height: 200px;
}

.sticky {
  position: fixed;top:80px; z-index: 10000;
}
.stickySide {
  position: fixed;top:130px; z-index: 99997;
}
header.vs-popup--header{
  display: none;
}
.divider-style{
  margin: 8px;
  width: 50px;
}
</style>